import { render } from "./addDataList.vue?vue&type=template&id=0afcb311&scoped=true"
import script from "./addDataList.vue?vue&type=script&lang=js"
export * from "./addDataList.vue?vue&type=script&lang=js"

import "./addDataList.vue?vue&type=style&index=0&id=0afcb311&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0afcb311"

export default script